import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Solo la URL incompleta /invoices/draft se bloquea. La creación ocurre únicamente
 * por POST desde un CTA; /invoices/draft/{id} recibe el ID emitido por el backend.
 */
export const Route = createFileRoute('/_app/invoices/draft/')({
  beforeLoad: () => {
    throw redirect({ to: '/invoices', replace: true })
  },
})
